<template>
  <div @click="handleClick">
    <slot></slot>
    <input
      ref="input"
      type="file"
      :accept="accept"
      name="files[]"
      style="display:none;"
      @change="onFileSelected($event)"
    >
    <canvas
      v-show="false"
      id="cropper"
    ></canvas>
  </div>
</template>
<script>
import { getFileExt } from '@/components/commonFunc/getFileType';
export default {
  props: {
    action: {
      type: String,
      required: true
    },
    //上传类型
    type: {
      type: String,
      default: '*'
    },
    accept: {
      type: String,
      default: '*'
    },
    // 文件大小限制,单位是M
    limit: {
      type: Number,
      default: 10
    },
    isUpload: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      targetFile: {},
      source: {}, //用于取消上传
      chunkNumber: 0, // 分片上传视频总片数
      audioUrl: ''
    };
  },
  mounted() {},
  methods: {
    handleClick() {
      this.$refs.input.click();
    },
    async onFileSelected(e) {
      // 选择视频
      if (!e.target.files.length) return;
      this.targetFile = e.target.files[0]; //拿到要上传的file对象
      let fileExt = await getFileExt(this.targetFile);
      if (fileExt !== 'MP4') {
        this.$emit('noSupported');
        this.$._loaded_ = void 0;
        return;
      }
      this.targetFile.duration = await this.getDuration(this.targetFile);

      // console.log('通过e与input都可以拿到files对象：',e.target.files==this.$refs.input.files);
      // 限制文件大小
      if (this.limit && this.targetFile.size / 1024 / 1024 > this.limit) {
        this.$emit('onOversize');
        this.$._loaded_ = void 0;
        return;
      }

      // let reader = new FileReader();
      // reader.readAsDataURL(this.targetFile);
      // reader.onloadstart = (e) => {
      //   this.$emit('onReadStart', e);
      // };
      // reader.onprogress = (e) => {
      //   this.$emit('onReadProgress', e);
      // }

      this.$._loaded_ = { loaded: 0, total: 1 };
      this.$emit('onReadStart', e);
      // 本地文件读取完成
      this.$emit('onReadOver', { file: this.targetFile });
      if (this.isUpload === false) {
        this.$._loaded_ = void 0;
        return;
      }
      //上传图片到服务器
      if (this.type == 'image') {
        const crop = false; // 是否执行图片自动裁切功能
        if (crop) {
          let file = this.cropImage() ? this.cropImage() : this.targetFile;
          this.uploadFile(this.action, file).then((res) => {
            this.$emit('onFinished', res);
            this.clearTargetFile();
          });
        } else {
          this.uploadFile(this.action, this.targetFile).then((res) => {
            this.$emit('onFinished', res);
            this.clearTargetFile();
          });
        }
      } else {
        //大视频分片上传
        this.uploadChunkFile();
      }
      // reader.onload = () => {
      // }
      // 本地文件读取完成
      // (reader.onloadend = () => this.$emit('onReadEnd', { file: this.targetFile, base64: reader.result }));
    },
    /**
     * 普通文件上传
     */
    uploadFile(url, data) {
      let p = new Promise((resolve, reject) => {
        var formData = new FormData();
        formData.append('files[]', data);
        this.$http({
          timeout: 1000 * 60 * 10,
          url: url,
          method: 'post',
          data: formData,
          headers: { 'Content-Type': 'multipart/form-data; boundary=---12321' },
          cancelToken: this.source.token,
          onUploadProgress: (e) => {
            // 属性lengthComputable主要表明总共需要完成的工作量和已经完成的工作是否可以被测量
            if (e.lengthComputable) {
              this.$emit('onProgress', { loaded: e.loaded, total: this.targetFile.size, e });
            }
          }
        })
          .then((res) => {
            resolve(res);
          })
          .catch(() => {
            reject(false);
          });
      });
      return p;
    },
    /**
     * 大文件切片上传
     */
    uploadChunkFile() {
      // 用于取消上传
      let CancelToken = this.$http.CancelToken;
      this.source = CancelToken.source();
      this.$._source_ = CancelToken.source();

      let filesize = this.targetFile.size; //文件整体大小
      let perSize = 6 * 1024 * 1024; //每片大小
      let chunkNumbers = Math.ceil(filesize / perSize); // 总片数，向上取整
      this.chunkNumber = chunkNumbers;
      // let index = 0; //当前上传
      let start = 0; //分片开头
      let end = 0; //分片结尾
      let filename = new Date().getTime() + '.mp4';
      let loaded = 0; //整体文件上传完成的动态进度
      // let _loaded = 0; //根据已上传完的片数得出的进度
      // console.log('loaded:',loaded);
      let arr = [];
      for (let i = 0; i < this.chunkNumber; i++) {
        arr.push(i);
      }

      const self = this;
      arr.reduce(function(sequence, index) {
        return sequence
          .then(function() {
            start = end;
            end = start + perSize;
            if (end > filesize) {
              end = filesize;
            }
            const chunk = self.targetFile.slice(start, end);
            const formData = new FormData();
            formData.append('files[]', chunk, filename);
            // formData.append('filename', filename);

            return self
              .$http({
                url: `/upload/fileBlock?currentChunkSize=${perSize}&index=${index}&chunkSize=${filesize}&totalChunks=${chunkNumbers}`,
                method: 'post',
                data: formData,
                // data: filename,
                headers: {
                  'Content-Type': 'multipart/form-data'
                  // 'filename': filename
                },
                cancelToken: self.source.token,
                onUploadProgress: () => {
                  // 属性lengthComputable主要表明总共需要完成的工作量和已经完成的工作是否可以被测量
                  // if (e.lengthComputable) {
                  //     loaded = _loaded + e.loaded;
                  //     self.$emit('onProgress',{loaded,total:filesize,e});
                  // }
                }
              })
              .catch((e) => console.warn(e));
          })
          .then(function(results) {
            // _loaded = (index+1)*2*1024*1024 ;
            if (!index) {
              loaded = index + 1;
            } else {
              loaded = index;
            }
            self.$emit('onProgress', { loaded, total: self.chunkNumber });
            self.$._loaded_ = { loaded, total: self.chunkNumber };
            self.$bus.emit('bus.onProgress', { loaded, total: self.chunkNumber });
            // console.log(loaded);
            // console.log("完成第" + index + "片文件上传");
            if (index + 1 === arr.length) {
              // 上传完成
              let filename = results.data.data.filename;
              let chunkNumber = self.chunkNumber;
              self.$http
                .post('/upload/mergeBlock', { filename: filename, chunkNumber: chunkNumber })
                .then((res) => {
                  self.$emit('onFinished', res);
                  self.$bus.emit('bus.onFinished', res);
                  self.clearTargetFile();
                  self.$._loaded_ = void 0;
                })
                .catch((err) => {
                  console.log(err);
                  self.$._loaded_ = void 0;
                });
            }
          })
          .catch((e) => {
            console.warn(e);
          });
      }, Promise.resolve());
    },
    /**
     * 获取媒体文件（音频及视频）的时长
     * deida: 上传时读取到的本地文件
     */
    getDuration(media) {
      // oncanplay是异步方法
      return new Promise((resolve) => {
        // let duration = 0;
        if (media.type.indexOf('video') == -1 && media.type.indexOf('audio') == -1) {
          resolve(0);
        }
        let mediaEl = document.createElement('audio');
        mediaEl.src =
          (window.createObjectURL && window.createObjectURL(media)) ||
          (window.URL && window.URL.createObjectURL(media)) ||
          (window.webkitURL && window.webkitURL.createObjectURL(media));
        mediaEl.oncanplay = () => {
          resolve(mediaEl.duration);
        };
      });
    },
    dataURItoBlob(base64Data) {
      var byteString;
      if (base64Data.split(',')[0].indexOf('base64') >= 0) byteString = atob(base64Data.split(',')[1]);
      else byteString = unescape(base64Data.split(',')[1]);
      var mimeString = base64Data
        .split(',')[0]
        .split(':')[1]
        .split(';')[0];
      var ia = new Uint8Array(byteString.length);
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      return new Blob([ia], { type: mimeString });
    },
    cancelHttp() {
      this.clearTargetFile()
      ;(this.source || this.$._source_).cancel('用户取消上传');
      this.$._loaded_ = void 0;
    },
    clearTargetFile() {
      if (this.$refs.input) {
        // 解决第二次点击input不会触发onchange事件的bug
        this.$refs.input.value = '';
      }
    },
    /**
     * 将图片裁切伟16:9的尺寸，并返回blob对象
     */
    cropImage() {
      let canvas = document.getElementById('cropper');
      let context = canvas.getContext('2d');
      let image = new Image();
      image.crossOrigin = 'Anonymous';
      // image.src = reader.result;
      image.onload = () => {
        let ratio = image.width / image.height;
        // 非16:9的自动裁剪
        if (ratio > 1.8 || ratio < 1.7) {
          let x = 0,
            y = 0,
            width = image.width,
            height = (width * 9) / 16;
          if (height > image.height) {
            height = image.height;
            width = (height * 16) / 9;
            // y = 0;
          } else {
            y = (image.height - height) / 2;
          }
          canvas.width = width;
          canvas.height = height;
          context.drawImage(image, x, y, width, height, 0, 0, width, height);
          let base64Data = canvas.toDataURL('image/png', 1.0);
          //封装blob对象
          var blob = this.dataURItoBlob(base64Data);
          return blob;
        } else {
          return false;
        }
      };
    }
  }
};
</script>
